import { MissingProgrammingRecordsFieldName } from '../missing-programming-records.types';

export const MISSING_PROGRAMMING_RECORDS_SORT_FIELD: Record<string, MissingProgrammingRecordsFieldName> = {
  commDeviceId: MissingProgrammingRecordsFieldName.CommDeviceId,
  initialTransmissionTime: MissingProgrammingRecordsFieldName.InitialTransmissionTime,
  lastTransmissionTime: MissingProgrammingRecordsFieldName.LastTransmissionTime
};
